<div class="tw:flex tw:items-center tw:justify-center tw:py-16 tw:w-full tw:h-full">
  <div class="tw:text-center tw:max-w-lg tw:px-4">
    <i class="fa-solid fa-triangle-exclamation fa-3x tw:mb-4 tw:text-red" aria-hidden="true"></i>
    <h2 class="tw:text-xl tw:font-semibold tw:mb-2 tw:text-slate-800">
      {{ title() }}
    </h2>
    <p class="tw:text-base tw:mb-6 tw:text-slate-600">{{ message() }}</p>
    @if (showRetry()) {
      <div class="tw:flex tw:gap-3 tw:justify-center">
        <button
          vee-btn="filled"
          (click)="retry.emit()"
          class="cyan tw:uppercase tw:tracking-wide"
          [attr.aria-label]="retryLabel()"
        >
          <i class="fa-solid fa-rotate-right" aria-hidden="true"></i>
          {{ retryLabel() }}
        </button>
      </div>
    }
  </div>
</div>

